// GLAMI welcome popup
// Shown on arrival from a ?glamivoucher=CODE link, announcing the percentage
// from window.glamiConfig. Structure mirrors influencer-popup.js so styling
// stays visually consistent with the existing influencer popup.

(function () {
  var GLAMI_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0573/1565/5835/files/glami_logo.png?v=1776528842';

  document.addEventListener('DOMContentLoaded', function () {
    var voucher = window.getGlamiVoucher && window.getGlamiVoucher();
    if (!voucher) return;

    // Only auto-show the popup on the landing navigation (when the URL param
    // is still present). Subsequent page loads keep the stored voucher active
    // but shouldn't re-open the modal.
    var params = new URLSearchParams(window.location.search);
    if (!params.get('glamivoucher')) return;

    setTimeout(function () {
      showGlamiPopup(voucher);
    }, 350);
  });

  function showGlamiPopup(voucher) {
    var popup = document.createElement('div');
    popup.className = 'glami-popup';
    popup.id = 'glami-popup';

    // Static shell only — all dynamic voucher values are injected via
    // textContent on the `data-slot` nodes below. Avoids building HTML strings
    // from voucher data, keeping the popup safe even if glamiConfig ever
    // accepts untrusted input in the future.
    popup.innerHTML =
      '<div class="glami-popup-background"></div>' +
      '<div class="glami-popup-content">' +
        '<button type="button" class="glami-popup-close" aria-label="' + (window.__T?.general?.a11y?.close || 'Close') + '">×</button>' +
        '<div class="glami-popup-container">' +
          '<div class="glami-popup-logo">' +
            '<img src="' + GLAMI_LOGO_URL + '" alt="GLAMI" style="display:block;margin:0 auto;height:38px;width:auto;max-width:100%;">' +
          '</div>' +
          '<h2 class="glami-popup-title">' + (window.__T?.popups?.glami?.title || 'Special offer from GLAMI') + '</h2>' +
          '<div class="glami-popup-urgency">' +
            '<span class="glami-popup-urgency-dot"></span>' +
            (window.__T?.popups?.glami?.urgency_badge || 'Limited offer — just this once') +
          '</div>' +
          '<div class="glami-popup-percent" data-slot="percent-badge"></div>' +
          '<p class="glami-popup-message">' +
            (window.__T?.popups?.glami?.discount_message || 'Your exclusive GLAMI discount of') +
            ' <strong data-slot="percent-inline"></strong> ' +
            (window.__T?.popups?.glami?.discount_message_2 || 'is now activated.') +
          '</p>' +
          '<div class="glami-popup-code">' +
            (window.__T?.popups?.glami?.code_label || 'Code:') + ' <strong data-slot="code"></strong>' +
          '</div>' +
          '<div class="glami-popup-actions">' +
            '<button type="button" class="glami-popup-button">' + (window.__T?.popups?.glami?.cta_button || 'View products') + '</button>' +
            '<div class="glami-popup-note">' + (window.__T?.popups?.glami?.hurry_note || 'Hurry! The offer expires soon.') + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    popup.querySelector('[data-slot="percent-badge"]').textContent = '-' + voucher.percentage + '%';
    popup.querySelector('[data-slot="percent-inline"]').textContent = '-' + voucher.percentage + '%';
    popup.querySelector('[data-slot="code"]').textContent = voucher.code;

    document.body.appendChild(popup);

    popup.querySelector('.glami-popup-close').addEventListener('click', closeGlamiPopup);
    popup.querySelector('.glami-popup-background').addEventListener('click', closeGlamiPopup);
    popup.querySelector('.glami-popup-button').addEventListener('click', closeGlamiPopup);

    addGlamiPopupStyles();

    setTimeout(function () {
      popup.classList.add('active');
    }, 100);
  }

  function closeGlamiPopup() {
    var popup = document.getElementById('glami-popup');
    if (!popup) return;
    popup.classList.remove('active');
    setTimeout(function () {
      popup.remove();
    }, 300);
  }

  function addGlamiPopupStyles() {
    if (document.getElementById('glami-popup-styles')) return;
    var style = document.createElement('style');
    style.id = 'glami-popup-styles';
    style.textContent =
      '.glami-popup{position:fixed;inset:0;z-index:2147483647;opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s;}' +
      '.glami-popup.active{opacity:1;visibility:visible;}' +
      '.glami-popup-background{position:absolute;inset:0;background:rgba(0,0,0,.75);}' +
      '.glami-popup-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:90%;max-width:520px;max-height:90vh;background:#fff;border-radius:10px;box-shadow:0 5px 20px rgba(0,0,0,.2);overflow:hidden;}' +
      '.glami-popup-close{position:absolute;top:12px;right:12px;width:30px;height:30px;background:none;border:none;font-size:24px;line-height:30px;text-align:center;cursor:pointer;z-index:10;}' +
      '.glami-popup-container{padding:32px 24px;text-align:center;overflow-y:auto;max-height:calc(90vh - 0px);}' +
      '.glami-popup-logo{margin:0 auto 14px;}' +
      '.glami-popup-title{font-size:20px;font-weight:700;margin:0 0 10px;color:#111;}' +
      '.glami-popup-urgency{display:inline-flex;align-items:center;gap:8px;padding:6px 14px;margin-bottom:14px;background:#f3efff;border:1px solid #7856FF;border-radius:999px;font-size:12px;font-weight:700;letter-spacing:.5px;color:#7856FF;text-transform:uppercase;}' +
      '.glami-popup-urgency-dot{width:8px;height:8px;border-radius:50%;background:#7856FF;animation:glami-pulse 1.2s ease-in-out infinite;}' +
      '@keyframes glami-pulse{0%,100%{transform:scale(1);opacity:1;}50%{transform:scale(1.4);opacity:.5;}}' +
      '.glami-popup-percent{font-size:52px;font-weight:800;color:#c81853;line-height:1;margin:10px 0 14px;}' +
      '.glami-popup-message{margin:0 0 18px;font-size:14px;line-height:1.5;color:#333;}' +
      '.glami-popup-code{display:inline-block;padding:10px 18px;margin-bottom:20px;background:#f7f7f7;border:1px dashed #c81853;border-radius:6px;font-size:14px;letter-spacing:1px;}' +
      '.glami-popup-code strong{color:#c81853;font-size:16px;}' +
      '.glami-popup-actions{display:flex;flex-direction:column;gap:10px;align-items:center;}' +
      '.glami-popup-button{padding:12px 30px;background:#c81853;color:#fff;border:1px solid #c81853;border-radius:5px;font-weight:600;cursor:pointer;transition:background .2s,border-color .2s;}' +
      '.glami-popup-button:hover{background:#a01445;border-color:#000;}' +
      '.glami-popup-note{font-size:15px;color:#111;font-weight:500;line-height:1.4;margin-top:4px;}' +
      '.glami-popup-note strong{color:#7856FF;font-weight:800;text-transform:uppercase;letter-spacing:.3px;}' +
      '@media(min-width:768px){.glami-popup-container{padding:40px 32px;}.glami-popup-title{font-size:24px;}.glami-popup-percent{font-size:64px;}}';
    document.head.appendChild(style);
  }
})();
